var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.75,
    height: 18,
    viewBox: "0 0 24.75 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.878
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.639
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "menu_book_FILL1_wght400_GRAD0_opsz48",
    d: "M16.625,14.356v-1.35a9.881,9.881,0,0,1,1.9-.591,10.236,10.236,0,0,1,2.039-.2A9.065,9.065,0,0,1,22,12.331q.7.112,1.378.281V13.85a7.8,7.8,0,0,0-2.812-.506,7.8,7.8,0,0,0-2.053.267A9.066,9.066,0,0,0,16.625,14.356Zm0,6.188V19.166a9.22,9.22,0,0,1,1.9-.577,11,11,0,0,1,2.039-.183A9.065,9.065,0,0,1,22,18.519q.7.113,1.378.281v1.238a7.8,7.8,0,0,0-2.812-.506,8.212,8.212,0,0,0-2.053.253A7.783,7.783,0,0,0,16.625,20.544Zm0-3.094V16.1a9.881,9.881,0,0,1,1.9-.591,10.236,10.236,0,0,1,2.039-.2A9.065,9.065,0,0,1,22,15.425q.7.113,1.378.281v1.238a7.8,7.8,0,0,0-2.812-.506,7.8,7.8,0,0,0-2.053.267A9.066,9.066,0,0,0,16.625,17.45Zm-1.35,6.019a14.154,14.154,0,0,1,2.756-1.055,11.345,11.345,0,0,1,2.869-.352,15.064,15.064,0,0,1,2.208.169,11.007,11.007,0,0,1,1.955.45V10.616a8.358,8.358,0,0,0-2.025-.7A10.35,10.35,0,0,0,20.9,9.687a9.4,9.4,0,0,0-2.939.464,10.959,10.959,0,0,0-2.686,1.308ZM14.431,26a11.32,11.32,0,0,0-3.122-1.645,10.629,10.629,0,0,0-3.459-.577,8.1,8.1,0,0,0-2.025.253,19.853,19.853,0,0,0-1.969.619A1.205,1.205,0,0,1,2.6,24.566,1.264,1.264,0,0,1,2,23.441V10.419a1.556,1.556,0,0,1,.2-.773A1.344,1.344,0,0,1,2.787,9.1a10.872,10.872,0,0,1,2.461-.83A12.7,12.7,0,0,1,7.85,8a12.479,12.479,0,0,1,3.445.478,10.993,10.993,0,0,1,3.136,1.463,10.678,10.678,0,0,1,3.08-1.463A12.083,12.083,0,0,1,20.9,8a12.493,12.493,0,0,1,2.587.267,10.919,10.919,0,0,1,2.447.83,1.433,1.433,0,0,1,.6.548,1.475,1.475,0,0,1,.211.773V23.441a1.333,1.333,0,0,1-.633,1.2,1.078,1.078,0,0,1-1.252.014,13.391,13.391,0,0,0-1.941-.633,8.55,8.55,0,0,0-2.025-.239,9.919,9.919,0,0,0-3.4.591A12.373,12.373,0,0,0,14.431,26Z",
    transform: "translate(-2 -8)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSop);
export default __webpack_public_path__ + "static/media/Sop.d6ce4ceb8e7076e04ab4c607c9e49305.svg";
export { ForwardRef as ReactComponent };